export default __webpack_public_path__ + "static/media/side.6245a7a6.svg";